import { fetchWrapper } from '../../utils';

export class groups {
  static baseUrl = process.env.REACT_APP_BASE_API + 'professor';

  /* Agrupamientos */
  static async getSchoolYears(params) {
    const url = `${this.baseUrl}/schoolyears`;
    params = params || {};
    return await fetchWrapper.post(url, params);
  }

  static async getLapses(params) {
    const url = `${this.baseUrl}/lapses`;
    return await fetchWrapper.post(url, params);
  }

  static async createLapse(params) {
    const url = `${this.baseUrl}/createlapse`;
    return await fetchWrapper.post(url, params);
  }

  static async deleteGroup(params) {
    const url = `${this.baseUrl}/deleteGroup`;
    return await fetchWrapper.post(url, params);
  }

  static async deleteLapse(params) {
    const url = `${this.baseUrl}/deletelapse`;
    return await fetchWrapper.post(url, params);
  }

  static async getGradesAndSections(filters) {
    const url = `${this.baseUrl}/grades-and-sections`;
    return await fetchWrapper.post(url, filters);
  }

  static async createSections(form) {
    const url = `${this.baseUrl}/createsection`;
    return await fetchWrapper.post(url, form);
  }

  static async updateSections(form) {
    const url = `${this.baseUrl}/update-grades-sections`;
    return await fetchWrapper.post(url, form);
  }

  static async deleteGrade(form) {
    const url = `${this.baseUrl}/deletegrade`;
    return await fetchWrapper.post(url, form);
  }

  static async getGrades(filters) {
    const url = `${this.baseUrl}/grades`;
    return await fetchWrapper.post(url, filters);
  }

  static async getSections(filters) {
    const url = `${this.baseUrl}/sections`;
    return await fetchWrapper.post(url, filters);
  }


  /* MATERAS */

  static async createSubjects(filters) {
    const url = `${this.baseUrl}/createSubjects`;
    return await fetchWrapper.post(url, filters);
  }

  static async getSubjects(filters) {
    const url = `${this.baseUrl}/gradesSubjects`;
    return await fetchWrapper.post(url, filters);
  }

  static async updateSubject(form) {
    const url = `${this.baseUrl}/updateSubject`;
    return await fetchWrapper.post(url, form);
  }

  static async deleteSubject(id) {
    const url = `${this.baseUrl}/deleteSubject`;
    return await fetchWrapper.post(url, id);
  }

  static async deleteSubjectByGrade(id) {
    const url = `${this.baseUrl}/deleteSubjectsByGrade`;
    return await fetchWrapper.post(url, id);
  }

  static async getUnassignedStudents(filters) {
    const url = `${this.baseUrl}/getUnassignedStudents`;
    return await fetchWrapper.post(url, filters);
  }

  static async assignSections(filters) {
    const url = `${this.baseUrl}/assignSections`;
    return await fetchWrapper.post(url, filters);
  }

  static async getNotification(filters) {
    const url = `${this.baseUrl}/notifications/get`;
    return await fetchWrapper.post(url, filters);
  }

  static async createNotification(filters) {
    const url = `${this.baseUrl}/notifications/create`;
    return await fetchWrapper.post(url, filters);
  }

  static async deleteNotification(filters) {
    const url = `${this.baseUrl}/notifications/delete`;
    return await fetchWrapper.post(url, filters);
  }

}
